import { FigureList, Figure } from "components/Figure"
import { useTranslator } from "components/Translator"
import { EyeRegular } from "components/Icon"
import sumBy from "lodash/sumBy"
import { LikesCounter } from "components/LikesCounter"
import { CommentsCounter } from "components/CommentsCounter"

export const AlbumFigures = ({ album }) => {
  const translator = useTranslator()

  const nbComments = album.medias
    ? sumBy(album.medias, (media) => media.nbComments)
    : null

  return (
    <FigureList>
      <FigureList>
        <li>
          <Figure
            icon={<EyeRegular className="w-4" />}
            label={translator.trans(
              "AlbumFigures.nbVisits",
              { nbVisits: album.nbVisits },
              "components",
            )}
          />
        </li>
        <li>
          <LikesCounter nbLikes={album.nbLikes} />
        </li>
        {nbComments !== null ? (
          <li>
            <CommentsCounter nbComments={nbComments} />
          </li>
        ) : null}
      </FigureList>
    </FigureList>
  )
}
